var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ClickEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class TabWithContentAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onClick = new ClickEventListener();
        /** @event */
        this.onDoubleClick = new ClickEventListener();
        /** @event */
        this.onContextMenuClick = new ClickEventListener();
    }
    /**
     * Gets the current active tab.
     */
    getActiveTab() {
        return this.state.activeTab;
    }
    /**
     * Sets the active tab.
     *
     * @param activeTab - The new active tab.
     */
    setActiveTab(activeTab) {
        this.setState({ activeTab });
    }
    /**
     * Gets the tab badge.
     */
    getBadge() {
        return this.state.badge;
    }
    /**
     * Sets the tab badge.
     *
     * @param badge - The new tab badge.
     */
    setBadge(badge) {
        this.setState({ badge });
    }
    /**
     * Gets the tab count.
     */
    getCount() {
        return this.state.count;
    }
    /**
     * Sets the tab count.
     *
     * @param count - The new count.
     */
    setCount(count) {
        this.setState({ count });
    }
    /**
     * Checks if the tab is enabled.
     */
    isEnabled() {
        return this.state.enabled;
    }
    /**
     * Sets if the tab should be enabled.
     *
     * @param enabled - If the tab should be enabled.
     */
    setEnabled(enabled) {
        this.setState({ enabled });
    }
    getIndex() {
        return this.state.index;
    }
    /**
     * Gets the tab label.
     */
    getLabel() {
        return this.state.label;
    }
    /**
     * Sets the tab label.
     *
     * @param label - The new tab label.
     */
    setLabel(label) {
        this.setState({ label });
    }
    /**
     * Gets the tab name.
     */
    getName() {
        return this.state.name;
    }
    /**
     * Sets the tab name.
     *
     * @param name - The new tab name.
     */
    setName(name) {
        this.setState({ name });
    }
    /**
     * Checks if the uppercase style is being applied to the tab label.
     */
    isUppercase() {
        return this.state.uppercase;
    }
    /**
     * Sets if the tab label should be uppercase.
     *
     * @param uppercase - If the tab label should be uppercase.
     */
    setUppercase(uppercase) {
        this.setState({ uppercase });
    }
    /**
     * Checks if the tab is visible.
     */
    isVisible() {
        return this.state.visible;
    }
    /**
     * Sets if the tab should be visible.
     *
     * @param visible - If the tab should be visible.
     */
    setVisible(visible) {
        this.setState({ visible });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TabWithContentAPI.prototype, "onClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TabWithContentAPI.prototype, "onDoubleClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TabWithContentAPI.prototype, "onContextMenuClick", void 0);
export { TabWithContentAPI, };
//# sourceMappingURL=tab-with-content-api.js.map